import React from 'react';
import { Eye, Users } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { useViewMode } from '../contexts/ViewModeContext';
import { cn } from '../lib/utils';

interface ViewModeToggleProps {
  className?: string;
  compact?: boolean;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({ className, compact = false }) => {
  const { isGuestView, canToggleView, toggleViewMode } = useViewMode();

  if (!canToggleView) {
    return null;
  }

  if (compact) {
    return (
      <div className={cn('flex items-center gap-2', className)}>
        <Eye
          className={cn('h-4 w-4', isGuestView ? 'text-primary' : 'text-muted-foreground')}
        />
        <Switch checked={isGuestView} onCheckedChange={toggleViewMode} aria-label="Toggle guest view" />
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <span
        className={cn(
          'text-sm font-medium transition-colors flex items-center gap-1',
          !isGuestView ? 'text-foreground' : 'text-muted-foreground'
        )}
      >
        <Users className="h-4 w-4" />
        Family
      </span>
      <Switch
        checked={isGuestView}
        onCheckedChange={toggleViewMode}
        aria-label="Toggle between family and guest view"
      />
      <span
        className={cn(
          'text-sm font-medium transition-colors flex items-center gap-1',
          isGuestView ? 'text-foreground' : 'text-muted-foreground'
        )}
      >
        <Eye className="h-4 w-4" />
        Guest
      </span>
    </div>
  );
};

export default ViewModeToggle;
